import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'

export const withHideInMobile = (WrappedComponent) => {
  return ({ display = 'block', sx = {}, component, ...props }) => {
    const finalDisplay =
      props.display === 'flex'
        ? 'flex'
        : component === 'span'
        ? 'inline-block'
        : display

    return (
      <WrappedComponent
        sx={{
          display: { xs: 'none', lg: finalDisplay },
          ...sx,
        }}
        {...props}
      />
    )
  }
}

export const withHideInDesktop = (WrappedComponent) => {
  return ({ display = 'block', sx = {}, component, ...props }) => {
    const finalDisplay =
      props.display === 'flex'
        ? 'flex'
        : component === 'span'
        ? 'inline-block'
        : display

    return (
      <WrappedComponent
        sx={{
          display: { xs: finalDisplay, lg: 'none' },
          ...sx,
        }}
        {...props}
      />
    )
  }
}

export const HideInMobileBox = withHideInMobile(Box)
export const HideInDesktopBox = withHideInDesktop(Box)

export const HideInMobileGrid = withHideInMobile(Grid)
export const HideInDesktopGrid = withHideInDesktop(Grid)
